import { render, staticRenderFns } from "./shipping-cost.vue?vue&type=template&id=60a5554c&"
import script from "./shipping-cost.vue?vue&type=script&lang=js&"
export * from "./shipping-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports